export default __webpack_public_path__ + "1a09f60e3df80d951d7a0d0b7c66dd00.png";